const canonicalize = (value) => {
    if (Array.isArray(value)) return value.map(canonicalize);
    if (value && typeof value === "object") {
        const sorted = {};
        for (const key of Object.keys(value).sort()) {
            sorted[key] = canonicalize(value[key]);
        }
        return sorted;
    }
    return value;
};

const push = (lines, prefix, value) => {
    lines.push(`${prefix}=${JSON.stringify(canonicalize(value))}`);
};

const addTargetFingerprint = (lines, target) => {
    const name = target.name || (target.isStage ? "_stage_" : "");
    const p = `target:${name}`;

    push(lines, `${p}.isStage`, !!target.isStage);
    push(lines, `${p}.x`, target.x);
    push(lines, `${p}.y`, target.y);
    push(lines, `${p}.direction`, target.direction);
    push(lines, `${p}.size`, target.size);
    push(lines, `${p}.visible`, target.visible);
    push(lines, `${p}.rotationStyle`, target.rotationStyle);
    push(lines, `${p}.draggable`, target.draggable);
    push(lines, `${p}.currentCostume`, target.currentCostume);
    push(lines, `${p}.volume`, target.volume);
    push(lines, `${p}.layerOrder`, target.layerOrder);
    if (target.isStage) push(lines, `${p}.tempo`, target.tempo);

    for (const [id, v] of Object.entries(target.variables || {}))
        push(lines, `${p}.variable:${id}`, v);
    for (const [id, v] of Object.entries(target.lists || {}))
        push(lines, `${p}.list:${id}`, v);
    for (const [id, v] of Object.entries(target.broadcasts || {}))
        push(lines, `${p}.broadcast:${id}`, v);
    for (const [id, block] of Object.entries(target.blocks || {}))
        push(lines, `${p}.block:${id}`, block);

    (target.costumes || []).forEach((costume, idx) => {
        push(lines, `${p}.costume:${idx}`, {
            assetId: costume.assetId,
            md5ext: costume.md5ext || costume.md5,
            name: costume.name,
            dataFormat: costume.dataFormat,
            rotationCenterX: costume.rotationCenterX,
            rotationCenterY: costume.rotationCenterY,
            bitmapResolution: costume.bitmapResolution,
        });
    });

    (target.sounds || []).forEach((sound, idx) => {
        push(lines, `${p}.sound:${idx}`, {
            assetId: sound.assetId,
            md5ext: sound.md5ext || sound.md5,
            name: sound.name,
            dataFormat: sound.dataFormat,
            rate: sound.rate,
            sampleCount: sound.sampleCount,
        });
    });
};

export const buildFingerprintLines = (project) => {
    const lines = [];
    for (const target of project?.targets || []) {
        addTargetFingerprint(lines, target);
    }
    lines.sort();
    return lines;
};

const toHex = (buffer) =>
    Array.from(new Uint8Array(buffer))
        .map((b) => b.toString(16).padStart(2, "0"))
        .join("");

export const hashProject = async (projectJsonOrString) => {
    const project =
        typeof projectJsonOrString === "string"
            ? JSON.parse(projectJsonOrString)
            : projectJsonOrString;

    const text = buildFingerprintLines(project).join("\n");
    const data = new TextEncoder().encode(text);
    const digest = await crypto.subtle.digest("SHA-256", data);
    return toHex(digest);
};
